import { CREATE_TYPE } from 'constants/NotificationConstants';
import { activityLogTypeHandler } from 'helpers/reducers/utils/activityLogTypeHandler';
import { normalizeEntities } from 'helpers/utilHelpers';

export const appendActivityLogHandler = (state, action, prepareTask) => {
  const { taskId, type, entity } = action.payload;
  if (entity !== 'Task') {
    return state;
  }

  const newState = activityLogTypeHandler(state, action, ['tasks', parseInt(taskId)]);
  if (type !== CREATE_TYPE) {
    return newState;
  }

  return newState.set(
    'tasks',
    normalizeEntities(
      [
        prepareTask({
          ...action.payload.content.newValues,
          ...action.payload.task,
          taskId: parseInt(action.payload.task.taskId),
          userId: parseInt(action.payload.task.userId),
        }),
      ],
      'taskId',
      newState.get('tasks'),
    ),
  );
};
